import { KNB } from '@nibfe/mkt-common-utils';
function queryStringify(obj) {
    function isIgnore(val) {
        return typeof val === 'function' || val === undefined;
    }
    function encode(val) {
        return encodeURIComponent(val);
    }
    function hasOwn(o, k) {
        return o.hasOwnProperty(k);
    }
    function isObject(val) {
        return Object.prototype.toString.call(val) === '[object Object]';
    }
    function getKey(key) {
        return key[0] + key.slice(1).map(i => `${encode('[')}${i}${encode(']')}`).join('');
    }
    function commonHandler(key, result, val) {
        if (!isIgnore(val)) {
            if (isObject(val)) {
                objectHandler(key, result, val);
                key.pop();
            }
            else if (Array.isArray(val)) {
                arrayHandler(key, result, val);
                key.pop();
            }
            else if (val === null) {
                result.push(`${getKey(key)}=`);
                key.pop();
            }
            else {
                result.push(`${getKey(key)}=${encode(val)}`);
                key.pop();
            }
        }
    }
    function objectHandler(key, result, obj) {
        for (let k in obj) {
            if (hasOwn(obj, k)) {
                key.push(k);
                commonHandler(key, result, obj[k]);
            }
        }
    }
    function arrayHandler(key, result, arr) {
        arr.forEach((val, k) => {
            key.push(k);
            commonHandler(key, result, val);
        });
    }
    const key = [];
    const result = [];
    if (!isObject(obj)) {
        return '';
    }
    objectHandler(key, result, obj);
    return result.join('&');
}
export default function addRequestSignature(type, requestUrl, data, headers) {
    // 此处注意data需要传字符串
    return new Promise(resolve => {
        // if (isMRN) {
        KNB.addRequestSignature({
            method: type,
            // 请求方法，仅支持POST和GET,string类型
            url: requestUrl,
            // 请求url，string类型
            body: JSON.stringify(data),
            // 请求body
            header: headers,
            //附加header信息，如果业务方漏填，KNB.js 会补充对应字段为""(空字符串）
            success: function (res) {
                if (typeof res.mtgsig === 'string') {
                    //若有mtsig证明客户端SDK为V4版本
                    // iOS 需要parse
                    // var sigHeader = {mtgsig:JSON.parse(res.mtgsig).mtgsig};  //封装成mtgsig对象，添加到请求头中
                    // self.requestForm.signatureHeader = sigHeader;
                    resolve(JSON.parse(res.mtgsig).mtgsig);
                    // res.mtgsig.mtgsig
                }
                else if (typeof res.mtgsig === 'object') {
                    // Android 不需要 parse
                    resolve(res.mtgsig.mtgsig);
                    // var sigHeader = {mtgsig:res.mtgsig.mtgsig};  //封装成mtgsig对象，添加到请求头中
                    // self.requestForm.signatureHeader = sigHeader;
                }
            },
            fail: function (err) {
                resolve('');
            }
        });
    });
}
// }else {
// resolve('')
// console.log('??????', window?.H5guard?.sign, requestUrl, type,headers)
// getRequestSign({
//   method: type,
//   requestUrl: requestUrl,
//   header: headers,
//   body: data
// }).then(res => {
//   console.log(res)
// })
// requestData.mtgsig = resRiskSign.mtgsig || UrlUtil.getQueryParam('mtgsig')
// window?.H5guard?.sign(
//   requestUrl,
//   type,
//   headers,
//  JSON.stringify(data),
//   // queryStringify(data),
//   signRes => {
//     console.log(signRes, 'signRes')
//       let sigUrl = requestUrl
//       let mtgsig = ''
//       if (signRes && signRes.url) {
//           sigUrl = signRes.url
//       }
//       if (signRes && signRes.headers && signRes.headers.mtgsig) {
//           mtgsig = signRes.headers.mtgsig
//       }
//       console.log(sigUrl, signRes)
//       resolve({ sigUrl, mtgsig })
//   },
//   false // 此处代表美团app环境下是否仍使用knb验签，可根据实际情况调整。建议传false，使用h5guard验签。
// )
// }
// window.KNB.addRequestSignature({
//   method: type,// 请求方法，仅支持POST和GET,string类型
//   url: requestUrl,// 请求url，string类型
//   body:JSON.stringify(data),// 请求body
//   header: headers, //附加header信息，如果业务方漏填，KNB.js 会补充对应字段为""(空字符串）
//   success: function(res){
//     if(typeof res.mtgsig === 'string'){  //若有mtsig证明客户端SDK为V4版本
//       // iOS 需要parse
//       // var sigHeader = {mtgsig:JSON.parse(res.mtgsig).mtgsig};  //封装成mtgsig对象，添加到请求头中
//       // self.requestForm.signatureHeader = sigHeader;
//       resolve(JSON.parse(res.mtgsig).mtgsig)
//       // res.mtgsig.mtgsig
//     } else if(typeof res.mtgsig === 'object'){
//       // Android 不需要 parse
//       resolve(res.mtgsig.mtgsig)
//       // var sigHeader = {mtgsig:res.mtgsig.mtgsig};  //封装成mtgsig对象，添加到请求头中
//       // self.requestForm.signatureHeader = sigHeader;
//     }
//   },
//   fail: function(err){
//     alert(JSON.stringify(err));
//   }
// })
// })
// }
